module.exports = __webpack_public_path__ + "static/media/cardhillo.47b45bb0.webp";